module.exports = __webpack_public_path__ + "static/mulching-mobile-4b056974c51ab5c02f02880d4d44a2a1.svg";